import { Injectable } from '@angular/core';
import { Validator, FormControl, FormGroup, AbstractControl } from '@angular/forms';

@Injectable()
export class EqualsValueValidator implements Validator {
  validator: Function;

  
  constructor() {
    this.validator = EqualsValueValidator.EqualsValueValidatorFactory(0, '');
  }

  validate(g: AbstractControl) {
    return this.validator(g);
  }

  static EqualsValueValidatorFactory(value: any, control: string) {
    return (g: AbstractControl) => {
            const group = g as FormGroup;
            const ctrl = group.get(control);
            
            const res = ctrl.value === value;

            return res ? null : {doNotEqualError: true};
        }
    }
}